<div class="col-12 px-3">
  <div class="row g-3">
    <div class="col-12">
      <app-contato-form [entidadeForm]="form" [dataSet]="dataSet" [paginaEntidade]="paginaEntidade" [contato]="contato" [paginaPessoa]="paginaPessoa"></app-contato-form>
    </div>

    <ng-container *ngIf="!paginaEntidade">
      <nz-divider></nz-divider>
      <div class="col-12 d-flex flex-column page-content border border-radius w-100 mb-2">
        <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
          (nzQueryParams)="sort($event)" [nzNoResult]="semDadosTemplate">
          <thead>
            <tr>
              <th nzColumnKey="tipoContato">Tipo Contato</th>
              <th nzColumnKey="principal">Principal</th>
              <th nzColumnKey="email">E-mail</th>
              <th nzColumnKey="telefone">Telefone</th>
              <th nzColumnKey="bairro">Bairro</th>
              <th nzColumnKey="municipio">Município</th>
              <th nzColumnKey="Estado">Estado</th>
              <th nzColumnKey="Estado">País</th>
              <th class="text-center" nzWidth="80px" [nzRight]="true">Ações</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of dataSet">
              <td>{{ item?.tipoContato?.nomeTipoContato }}</td>
              <td>{{ item?.flagPrincipal === true ? 'Sim' : 'Não' }}</td>
              <td>{{ item?.email }}</td>
              <td>{{ item?.telefone | telefoneXX }}</td>
              <td>{{ item?.enderecoBairro }}</td>
              <td>{{ item?.enderecoMunicipio?.nome }}</td>
              <td>{{ item?.enderecoUf?.nome }}</td>
              <td>{{ item?.pais?.nome }}</td>
              <td class="text-center" [nzRight]="true">
                <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
                  <span nz-icon nzType="more" nzTheme="outline"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                    <li nz-menu-item type="button" (click)="editarItem(item)">
                      <a> Detalhes / Editar</a>
                    </li>
                    <li nz-menu-item type="button" (click)="removerContato(item)">
                      <a> Remover </a>
                    </li>
                  </ul>
                </nz-dropdown-menu>
              </td>
            </tr>
          </tbody>
        </nz-table>
        <ng-template #footerTemplate>
          <section class="d-flex justify-content-end w-100">
            <app-pagination [itemPorPagina]="10"></app-pagination>
          </section>
        </ng-template>
        <ng-template #semDadosTemplate>
          <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
            <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
          </div>
        </ng-template>
      </div>
    </ng-container>
  </div>
</div>
